import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-page-loaders',
  templateUrl: './page-loaders.component.html',
  styleUrls: ['./page-loaders.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class PageLoadersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/page-loaders/page-loaders.component.ts